import { Box, Card, CardContent, Skeleton, Stack } from "@mui/material";

export const CameraConfigCardShimmer = () => {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        p: 1,
        width: "100%",
        boxSizing: "border-box",
        borderColor: "divider",
      }}
    >
      {/* Camera preview */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          aspectRatio: "16 / 9",
          overflow: "hidden",
          borderRadius: 1,
        }}
      >
        <Skeleton
          variant="rectangular"
          animation="wave"
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            transform: "none",
          }}
        />

        {/* Online badge */}
        <Box
          sx={{
            position: "absolute",
            top: 8,
            left: 8,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            px: 1,
            py: 0.35,
            bgcolor: "rgba(255,255,255,0.9)",
            borderRadius: 1,
          }}
        >
          <Skeleton variant="circular" width={7} height={7} />
          <Skeleton variant="text" width={38} height={18} />
        </Box>

        {/* Refresh button */}
        <Skeleton
          variant="circular"
          animation="wave"
          width={32}
          height={32}
          sx={{
            position: "absolute",
            top: 7,
            right: 7,
            bgcolor: "rgba(255,255,255,0.85)",
          }}
        />

        {/* Center play button */}
        <Skeleton
          variant="circular"
          animation="wave"
          width={40}
          height={40}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "rgba(255,255,255,0.9)",
          }}
        />

        {/* Camera snapshot label */}
        <Skeleton
          variant="rounded"
          animation="wave"
          width={104}
          height={20}
          sx={{
            position: "absolute",
            bottom: 8,
            left: 8,
            bgcolor: "rgba(255,255,255,0.8)",
          }}
        />
      </Box>

      {/* Camera details */}
      <CardContent
        sx={{
          p: "12px 6px 10px !important",
          "&:last-child": {
            pb: 1,
          },
        }}
      >
        {/* Title and action icons */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
          sx={{ mb: 0.5 }}
        >
          <Skeleton variant="text" animation="wave" width="42%" height={27} />

          <Stack direction="row" spacing={1}>
            <Skeleton
              variant="rounded"
              animation="wave"
              width={32}
              height={30}
              sx={{ borderRadius: 1 }}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              width={30}
              height={30}
              sx={{ borderRadius: 1 }}
            />
          </Stack>
        </Stack>

        {/* Description and stream count */}
        <Skeleton
          variant="text"
          animation="wave"
          width="67%"
          height={23}
          sx={{ mb: 1 }}
        />

        {/* Divider */}
        <Box
          sx={{
            borderTop: 1,
            borderColor: "divider",
            mb: 1,
          }}
        />

        {/* Created by */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
          sx={{ mb: 0.35 }}
        >
          <Skeleton variant="text" animation="wave" width="29%" height={22} />
          <Skeleton variant="text" animation="wave" width="60%" height={22} />
        </Stack>

        {/* Updated by */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <Skeleton variant="text" animation="wave" width="29%" height={22} />
          <Skeleton variant="text" animation="wave" width="60%" height={22} />
        </Stack>
      </CardContent>
    </Card>
  );
};
